import { PORTAL_PATH } from "@/layouts/portal/portalNavigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Old path: keep links working.
export const Route = createFileRoute("/vendor/produk/")({
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad: () => {
		throw redirect({ to: PORTAL_PATH.Product, search: true, replace: true });
	},
});
